import React from "react";
import Print from "@components/Print";
import Table from './table';

class Example extends React.Component {
  render() {
    return (
        <Print
            {...this.props}
            button="Imprimir lista de aniversariantes"
            printComponent={Table}
            ref={el => (this.componentRef = el)}
        />
    );
  }
}

export default Example;
